import { legacySftpConnectorApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';

export const runLegacySftpAction = catchAsyncActionError(({ dryRun }) => async () => {
  const { data } = await legacySftpConnectorApi.run({ dryRun });

  return data;
});
